var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":"2x"},on:{"click":_vm.switchFolded}})}
var staticRenderFns = []

export { render, staticRenderFns }